/**
 * Where to go after login. Login (SSO) leaves the app with full-page
 * redirects, so a deep link like the MCP consent page is kept in
 * sessionStorage, not in router state. Only same-app paths are accepted.
 */
const KEY = 'adminportal:return-to'

const isAppPath = (path: string) =>
  path.startsWith('/') && !path.startsWith('//')

export const rememberReturnTo = (path: string) => {
  try {
    if (isAppPath(path) && path !== '/login') sessionStorage.setItem(KEY, path)
  } catch {
    // storage unavailable: login lands on the home page as before
  }
}

export const readReturnTo = (): string | undefined => {
  try {
    const path = sessionStorage.getItem(KEY) ?? undefined

    return path && isAppPath(path) ? path : undefined
  } catch {
    return undefined
  }
}

export const clearReturnTo = () => {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nothing to clear
  }
}
